<template>
    <div>
        <p class="block text-base md:text-lg leading-6 text-gray-700 font-poppins font-bold">
            Good To Know
        </p>
        <div class="block mt-4">
            <span class="flex items-center">
                <svg v-if="isWhiteLabel" class="w-10 h-10 block lg:block flex-shrink-0" width="25" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107"><defs></defs>
                    <g transform="translate(-16 0.005)">
                        <path class="shield-check-a" d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)"/>
                        <path class="shield-check-b" d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)"/>
                    </g>
                </svg>
                <svg v-else-if="shields" class="block lg:block flex-shrink-0 w-10 h-10" xmlns="http://www.w3.org/2000/svg" width="25" height="28" viewBox="0 0 65.729 70.107">
                        <defs>
                        </defs>
                        <g transform="translate(-16 0.005)">
                            <path :class="{'shield-check-a': !free, 'free-shield-a': free}"
                                  d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z"
                                  transform="translate(0 0)" />
                            <path :class="{'shield-check-b': !free, 'free-shield-b': free}"
                                  d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z"
                                  transform="translate(-75.994 -127.76)" />
                        </g>
                </svg>
                <span v-else class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-cyan rounded-full group-hover:bg-blue-800">
                    <!-- Heroicon name: check -->
                    <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                    </svg>
                </span>
                <span class="ml-4">We fix 4 out of 5 vehicles at the roadside</span>
            </span>
        </div>

        <div class="block mt-4">
            <span class="flex items-center">
                <svg v-if="isWhiteLabel" class="w-10 h-10 block lg:block flex-shrink-0" width="25" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107"><defs></defs>
                    <g transform="translate(-16 0.005)">
                        <path class="shield-check-a" d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)"/>
                        <path class="shield-check-b" d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)"/>
                    </g>
                </svg>
                <svg v-else-if="shields" class="block lg:block flex-shrink-0 w-10 h-10" xmlns="http://www.w3.org/2000/svg" width="25" height="28" viewBox="0 0 65.729 70.107">
                        <defs>
                        </defs>
                        <g transform="translate(-16 0.005)">
                            <path :class="{'shield-check-a': !free, 'free-shield-a': free}"
                                  d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z"
                                  transform="translate(0 0)" />
                            <path :class="{'shield-check-b': !free, 'free-shield-b': free}"
                                  d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z"
                                  transform="translate(-75.994 -127.76)" />
                        </g>
                </svg>
                <span v-else class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-cyan rounded-full group-hover:bg-blue-800">
                    <!-- Heroicon name: check -->
                    <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                    </svg>
                </span>
                <span class="ml-4" v-if="isPersonalCover">You are covered, no matter what vehicle you're driving</span>
                <span class="ml-4" v-else>The vehicle is covered, no matter who is driving</span>
            </span>
        </div>

        <div class="block mt-4">
            <span class="flex items-center">
                <svg v-if="isWhiteLabel" class="w-10 h-10 block lg:block flex-shrink-0" width="25" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107"><defs></defs>
                    <g transform="translate(-16 0.005)">
                        <path class="shield-check-a" d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)"/>
                        <path class="shield-check-b" d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)"/>
                    </g>
                </svg>
                <svg v-else-if="shields" class="block lg:block flex-shrink-0 w-10 h-10" xmlns="http://www.w3.org/2000/svg" width="25" height="28" viewBox="0 0 65.729 70.107">
                        <defs>
                        </defs>
                        <g transform="translate(-16 0.005)">
                            <path :class="{'shield-check-a': !free, 'free-shield-a': free}"
                                  d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z"
                                  transform="translate(0 0)" />
                            <path :class="{'shield-check-b': !free, 'free-shield-b': free}"
                                  d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z"
                                  transform="translate(-75.994 -127.76)" />
                        </g>
                </svg>
                <span v-else class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-cyan rounded-full group-hover:bg-blue-800">
                    <!-- Heroicon name: check -->
                    <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                    </svg>
                </span>
                <span class="ml-4">We cover all hybrid and electric cars as standard</span>
            </span>
        </div>

        <div class="hidden md:block">
            <p class="font-sm text-left font-semibold pt-4">We accept:</p>
            <payment-icons/>
        </div>

        <div v-if="showTrustpilot" class="block md:hidden mt-6">
            <!-- TrustBox widget - Micro Star -->
            <div ref="trustboxMobile" class="trustpilot-widget" data-locale="en-GB" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="5d88b4f90f1ce20001cb981f" data-style-height="24px" data-style-width="100%" data-theme="light">
                <a href="https://uk.trustpilot.com/review/motoringassistance.com" target="_blank" rel="noopener">Trustpilot</a>
            </div>
        </div>

    </div>
</template>

<script>
import commonMethods from '../common/methods'
import PaymentIcons from './PaymentIcons.vue'

export default {
    name: "WhyChooseUs",
    components: {PaymentIcons},
    data() {
        return {
            free: false,
        }
    },
    props: {
        isWhiteLabel: {
            type: Boolean,
            default: false
        },
        shields: {
            type: Boolean,
            default: false
        },
        isPersonalCover: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        showTrustpilot: function () {
            return window.baseUrl.includes('motoringassistance')
        }
    },
    methods: {
        ...commonMethods,
    },
    async mounted() {
        this.loadTrustpilotWidget(this.$refs.trustboxMobile)
    }
}
</script>
